import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'PatentSpecification',
  props: { patent: { type: Object, default: () => ({}) } },
  setup(__props) {

const props = __props;



const descriptionData = computed<string>(() => (props.patent?.patentText || {}).specification || "");

// 与原版 formatSpecification 一致: 高亮章节标题(CN/EN), 换行转 <br>
const formattedDescription = computed<string>(() => {
  const value = descriptionData.value;
  if (!value) return "";
  const text = value.replace(/\r?\n/g, "<br/>");
  if ((props.patent?.patentNo || "").indexOf("CN") === 0) {
    return text.replace(
      /(所属技术领域|技术领域|发明内容|实用新型内容|背景技术|附图说明|具体实施方式|详细描述[\n:：]|\n附图[描简]述\n|\n背景\n|\n简要概述\n|\n概述\n)/g,
      (r: string) => "<br/><span style='color:crimson;'>" + r + "</span><br/>"
    );
  }
  return text.replace(
    /(TECHNICAL FIELD|BACKGROUND OF THE INVENTION|SUMMARY OF THE INVENTION|DETAILED DESCRIPTION OF THE INVENTION)/g,
    (r: string) => "<br/><span style='color:crimson;font-weight:bold;'>" + r + "</span><br/>"
  );
});

return { __sfc: true,props, descriptionData, formattedDescription }
}

})